import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext } from 'react'
import { SubcontractorRequest } from 'src/interfaces/subcontractor'

export interface ISubcontractorRequestsTableContext {
  searchQuery: string
  setSearchQuery(value: string): void

  masterContractorFilter: Array<string>
  setMasterContractorFilter(masterContractorFilter: Array<string>): void

  actionAnchor: null | HTMLElement
  subcontractorRequestToAction: SubcontractorRequest | null
  openSubcontractorRequestItemAction(
    event: React.MouseEvent<HTMLButtonElement>,
    subcontractorRequest: SubcontractorRequest,
  ): void
  closeSubcontractorRequestItemAction(): void
  clearSubcontractorRequestToAction(): void

  selectedSubcontractorRequestIds: GridRowSelectionModel
}

export const SubcontractorRequestsTableContext = createContext<ISubcontractorRequestsTableContext>({
  searchQuery: '',
  setSearchQuery: () => {},

  masterContractorFilter: [],
  setMasterContractorFilter: () => {},

  actionAnchor: null,
  subcontractorRequestToAction: null,
  openSubcontractorRequestItemAction: () => {},
  closeSubcontractorRequestItemAction: () => {},
  clearSubcontractorRequestToAction: () => {},

  selectedSubcontractorRequestIds: [],
})
